import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import { Controller, RegisterOptions } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export interface PhoneInputProps {
  name: string;
  label: string;
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  control?: any;
  errors?: any;

  placeholder?: string;
  disabled?: boolean;
}

export const PhoneNumInputBasic = ({
  name,
  rules,
  control,
  label,
  labelIcon,
  errors,
  placeholder = 'Enter phone number',
  disabled,
  ...rest
}: PhoneInputProps) => {
  return (
    <>
      <Label label={label} labelIcon={labelIcon}>
        <Controller
          render={({ field }) => (
            <PhoneInput
              {...field}
              control={control}
              disabled={disabled}
              defaultCountry="US"
              className="form__input "
              placeholder={placeholder}
            />
          )}
          name={name}
          rules={rules}
          control={control}
          defaultValue={''}
        />
        {errors && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        )}
      </Label>
    </>
  );
};
